export const PHONE_PE_RESET_STATE = 'PHONE_PE_RESET_STATE';
export const PHONE_PE_CURRENT_ITEM = 'PHONE_PE_CURRENT_ITEM';

export const PHONE_PE_REQUEST_LOADING = 'PHONE_PE_REQUEST_LOADING';
export const PHONE_PE_REQUEST_SUCCESS = 'PHONE_PE_REQUEST_SUCCESS';
export const PHONE_PE_REQUEST_FAILED = 'PHONE_PE_REQUEST_FAILED';

export const PHONE_PE_CURRENT_ACTION = 'PHONE_PE_CURRENT_ACTION';
export const PHONE_PE_RESET_ACTION = 'PHONE_PE_RESET_ACTION';